import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { navigation } from '../navigation/navigation';
import { Branch } from '../shared/model/Branch.model';
import { Terminal } from '../shared/model/Terminal.model';
import { EventService } from './event.service';

export enum enumUserRole {
  DevMode = 200,
  Admin = 100,
  Manager = 50,
  User = 10,
}

@Injectable({ providedIn: 'root' })
export class NavigationService implements OnDestroy {
  navigation: any;
  eventServiceSub: Subscription;
  privs: string = "";
  branch: Branch = null;
  terminal: Terminal = null;
  resourceTypeCount = 0;
  loginAs = false;
  FeatureQueueManagerEnabled: boolean = false;
  FeatureVouchersEnabled:boolean=false;
  displayRota: boolean = false;

  constructor(
    private eventService: EventService) {
    console.log("Starting Navigation Service");

    this.eventServiceSub = this.eventService.onDefaultDataChanged.subscribe(d => {
      this.resourceTypeCount = d.ResourceTypes.filter((i) => i.UseQueueManager !== false).length;
      this.FeatureQueueManagerEnabled = d.FeatureQueueManagerEnabled || false;
      this.FeatureVouchersEnabled = d.AS365FeatureFlags.Vouchers || false;
      this.displayRota = d.customerSettings.DisplayRota || false;
      this.updateNavigation();
    });

    this.updateNavigation();
  }

  SetBranch(branch: Branch) {
    this.branch = branch;
    this.updateNavigation();
  }

  SetTerminal(terminal: Terminal) {
    this.terminal = terminal;
    this.updateNavigation();
  }

  SetEmployeePrivs(privs: string) {
    // setup properties from args
    this.privs = privs;
    this.updateNavigation();
  }

  SetLoginAs(loginAs: boolean) {
    this.loginAs = loginAs;
    this.updateNavigation();
  }

  ngOnDestroy() {
    if (this.eventServiceSub) this.eventServiceSub.unsubscribe();
    this.eventServiceSub = null;
  }

  updateNavigation(): any {
    const nav: any = navigation;
    let role = this.GetRole(this.privs);

    if (environment.production == false)
      role = enumUserRole.DevMode;

    this.CheckMenuItemPrivs(role, nav[0], this.loginAs);
    return nav;
  }

  GetRole(priv: string): enumUserRole {
    let role = enumUserRole.User;
    if (priv && (priv.trim().toLowerCase().includes('manager'))) { role = enumUserRole.Manager; }
    if (priv && (priv.trim().toLowerCase().includes('admin'))) { role = enumUserRole.Admin; }
    if (priv && (priv.trim().toLowerCase().includes('dev'))) { role = enumUserRole.DevMode; }

    return role;
  }

  CheckMenuItemPrivs(userRole: enumUserRole, nav: any, loginAs: boolean) {
    var menuVisibleCount: number = 0;
    var subMenuVisibleCount: number = 0;

    if (nav.children && nav.children.length > 0) {
      nav.children.forEach((child) => {
        subMenuVisibleCount = subMenuVisibleCount + this.CheckMenuItemPrivs(userRole, child, loginAs);
      });
      if (subMenuVisibleCount > 0) {
        nav.hidden = false;
      }
    }

    if (nav.priv) {
      var requiredPriv: enumUserRole = this.GetRole(nav.priv);
      nav.hidden = !(userRole >= requiredPriv);
      if (!nav.hidden)
        menuVisibleCount = menuVisibleCount + 1;
    }
    else {
      nav.hidden = false;
      menuVisibleCount = menuVisibleCount + 1;
    }

    if (nav.RequireTill === true && (this.terminal == undefined || this.terminal?.TillConnected == false || this.terminal?.Branch != this.branch?.BranchId)) {
      nav.hidden = true;
    }
    else {
      if (nav.id === 'queueManager') {
        nav.hidden = (this.resourceTypeCount < 1 || this.FeatureQueueManagerEnabled == false);
      }

      if (nav.hidden === false) menuVisibleCount++;
    }

    // Hide Vouchers if not enabled.
    if (this.FeatureVouchersEnabled==false && nav.id=="vouchers")
      nav.hidden=true;

    if (nav.id === 'employee_rota') {
      if (userRole === enumUserRole.User && this.displayRota) {
        nav.hidden = false;
      } else {
        nav.hidden = true;
      }
    }

    return menuVisibleCount;
  }

  addNavItem(nav: any, index: number, navItem: any) {
    nav[0].children.splice(index, 0, navItem);
  }

  addSubItem(nav: any, navigationChildId: number, navItem: any) {
    const parent = nav[0].children[navigationChildId];
    if (parent.type !== 'collapse') {
      parent.type = 'collapse';
      parent.children = [];
    }
    parent.children.push(navItem);
  }

  updateBadge(nav: any, navigationChildId: number, title: number) {
    const navItem = nav[0].children[navigationChildId];
    navItem.badge.title = title;
  }
}

// export class NavigationHelper {
//   static privs: string = "";
//   static branch: Branch = null;
//   static terminal: Terminal = null;
//   static NHId: Date = new Date();

//   constructor() {
//     console.log("Navigation Helper CTOR");
//   }

//   static updateNavigation(): any {
//     const nav: any = navigation;
//     let role = this.GetRole(this.privs);
//     this.CheckMenuItemPrivs(role, nav[0]);
//     return nav;
//   }

//   static GetRole(priv: string): enumUserRole {
//     let role = enumUserRole.User;
//     if (priv && (priv.trim().toLowerCase().includes('manager'))) { role = enumUserRole.Manager; }
//     if (priv && (priv.trim().toLowerCase().includes('admin'))) { role = enumUserRole.Admin; }
//     return role;
//   }

//   static CheckMenuItemPrivs(userRole: enumUserRole, nav: any) {
//     var menuVisibleCount: number = 0;
//     var subMenuVisibleCount: number = 0;

//     if (nav.children && nav.children.length > 0) {
//       nav.children.forEach((child) => {
//         subMenuVisibleCount = subMenuVisibleCount + this.CheckMenuItemPrivs(userRole, child);
//       });
//       if (subMenuVisibleCount > 0) {
//         nav.hidden = false;
//       }
//     }

//     if (nav.priv) {
//       var requiredPriv: enumUserRole = this.GetRole(nav.priv);
//       nav.hidden = !(userRole >= requiredPriv);
//       if (!nav.hidden)
//         menuVisibleCount = menuVisibleCount + 1;
//     }
//     else {
//       nav.hidden = false;
//       menuVisibleCount = menuVisibleCount + 1;
//     }

//     if (nav.RequireTill === true && (NavigationHelper.terminal == undefined || NavigationHelper.terminal.TillConnected == false || NavigationHelper.terminal.Branch != NavigationHelper.branch.BranchId)) {
//       nav.hidden = true;
//       console.log("NavHelper Hide : " + nav.id + " TillRequired  " + NavigationHelper.terminal + " Branch : " + NavigationHelper.branch);
//     }
//     else
//       console.log("NavHelper Show : " + nav.id + " TillRequired  " + NavigationHelper.terminal + " Branch : " + NavigationHelper.branch);

//     if (nav.hidden === false)
//       menuVisibleCount++;

//     return menuVisibleCount;
//   }

//   static addNavItem(nav: any, index: number, navItem: any) {
//     nav[0].children.splice(index, 0, navItem);
//   }

//   static addSubItem(nav: any, navigationChildId: number, navItem: any) {
//     const parent = nav[0].children[navigationChildId];
//     if (parent.type !== 'collapse') {
//       parent.type = 'collapse';
//       parent.children = [];
//     }
//     parent.children.push(navItem);
//   }

//   static updateBadge(nav: any, navigationChildId: number, title: number) {
//     const navItem = nav[0].children[navigationChildId];
//     navItem.badge.title = title;
//   }
// }
